import { AOPExecution } from '../types/AOPExecutionTypes';

/**
 * The newest Radar run on a work order.
 *
 * Only this one question is kept in the store, and deliberately so: a run's
 * event history is a cursor-paged feed that one screen reads and keeps, and
 * holding that would need a page-merging policy nothing wants. What two
 * separate surfaces on the work-order page both ask — the Radar banner and the
 * "Radar Activity" tab gate — is the single newest run, and that is worth
 * asking once.
 */
export const AGENT_EXECUTIONS_NEWEST_SUCCESS = 'AGENT_EXECUTIONS_NEWEST_SUCCESS';

export interface NewestExecutionSuccessAction {
	type: typeof AGENT_EXECUTIONS_NEWEST_SUCCESS;
	workOrderId: number;
	/** `null` says Radar has never run there — a settled answer, not an absence. */
	execution: AOPExecution | null;
}

export const newestExecutionSuccess = (
	workOrderId: number,
	execution: AOPExecution | null
): NewestExecutionSuccessAction => ({
	type: AGENT_EXECUTIONS_NEWEST_SUCCESS,
	workOrderId,
	execution,
});
